export const InternalOrderDeliveryAddress = (
	json: IInternalOrderDeliveryAddress,
): IInternalOrderDeliveryAddressModel => {
	const { building_number, apartment_number, custom_name, ...rest } = json

	return {
		...rest,
		buildingNumber: building_number,
		apartmentNumber: apartment_number,
		customName: custom_name,
	}
}

export const InternalOrderItemTray = (json: IInternalOrderItemTray): IInternalOrderItemTrayModel => json

export const InternalOrderItem = (json: IInternalOrderItem): IInternalOrderItemModel => {
	const {
		meal_id,
		variant_id,
		size_id,
		meal_kind,
		meal_category,
		meal_type,
		meal_subkind,
		addon_category,
		client_name,
		size_name,
		thumb_url,
		kitchen_thumb_url,
		trays,
		created_at,
		updated_at,
		...rest
	} = json

	return {
		...rest,
		mealId: meal_id,
		variantId: variant_id,
		sizeId: size_id,
		mealKind: meal_kind,
		mealCategory: meal_category,
		mealType: meal_type,
		mealSubkind: meal_subkind,
		addonCategory: addon_category,
		clientName: client_name,
		sizeName: size_name,
		thumbUrl: thumb_url,
		kitchenThumbUrl: kitchen_thumb_url,
		trays: trays.map(t => InternalOrderItemTray(t)),
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const InternalOrder = (json: IInternalOrder): IInternalOrderModel => {
	const {
		custom_name,
		cost_direction,
		production_date,
		delivery_date,
		employee_first_name,
		employee_last_name,
		delivery_address,
		items,
		...rest
	} = json

	return {
		...rest,
		customName: custom_name,
		costDirection: cost_direction ?? '',
		productionDate: production_date,
		deliveryDate: delivery_date,
		employeeFirstName: employee_first_name,
		employeeLastName: employee_last_name,
		deliveryAddress: InternalOrderDeliveryAddress(delivery_address),
		items: items.map(i => InternalOrderItem(i)),
	}
}
